<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1200px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="sequence"
              attribute="attributes.sort"
              :label="$t('attributes.sort')"
            >
              <b-select v-model="form.sequence" name="sequence">
                <option
                  v-for="option in sequence_range"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="subtitle"
              :label="$t('attributes.sub_title')"
            >
              <b-input
                v-model="form.subtitle"
                name="subtitle"
                :placeholder="
                  $t('message.please_input') + $t('attributes.sub_title')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="quantity"
              :label="$t('attributes.quantity')"
            >
              <b-input
                v-model.number="form.quantity"
                name="quantity"
                type="number"
                min="1"
                :placeholder="
                  $t('message.please_input') + $t('attributes.quantity')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="adult_cost"
              :label="$t('attributes.adult_cost')"
            >
              <b-input
                v-model.number="form.adult_cost"
                name="adult_cost"
                type="number"
                min="0"
                :placeholder="
                  $t('message.please_input') + $t('attributes.adult_cost')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="adult_tip"
              :label="$t('attributes.adult_tip')"
            >
              <b-input
                v-model="form.adult_tip"
                name="adult_tip"
                :placeholder="
                  $t('message.please_input') + $t('attributes.adult_tip')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="child_cost"
              :label="$t('attributes.child_cost')"
            >
              <b-input
                v-model.number="form.child_cost"
                name="child_cost"
                type="number"
                min="0"
                :placeholder="
                  $t('message.please_input') + $t('attributes.child_cost')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="child_tip"
              :label="$t('attributes.child_tip')"
            >
              <b-input
                v-model="form.child_tip"
                name="child_tip"
                :placeholder="
                  $t('message.please_input') + $t('attributes.child_tip')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="baby_cost"
              :label="$t('attributes.baby_cost')"
            >
              <b-input
                v-model.number="form.baby_cost"
                name="baby_cost"
                type="number"
                min="0"
                :placeholder="
                  $t('message.please_input') + $t('attributes.baby_cost')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="baby_tip"
              :label="$t('attributes.baby_tip')"
            >
              <b-input
                v-model="form.baby_tip"
                name="baby_tip"
                :placeholder="
                  $t('message.please_input') + $t('attributes.baby_tip')
                "
                expanded
              >
              </b-input>
            </form-group>

            <b-field horizontal grouped :label="$t('attributes.picture') + '1'">
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPicture(1)">
                  <b-icon icon="upload"></b-icon>
                  <span>{{
                    $t('message.please_input') + $t('attributes.picture') + '1'
                  }}</span>
                </a>
                <p
                  v-if="form.picture1"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px; border-radius: 4px 0 0 4px;"
                >
                  <a
                    :href="productImageUrl(form.picture1)"
                    @click.prevent="onClickImage(form.picture1)"
                  >
                    {{ form.picture1 }}
                  </a>
                </p>
                <button
                  v-if="form.picture1"
                  class="button is-danger"
                  style="height: 40px; border-radius: 0 4px 4px 0;"
                  @click="form.picture1 = null"
                >
                  X
                </button>
              </b-field>
            </b-field>

            <b-field horizontal grouped :label="$t('attributes.picture') + '2'">
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPicture(2)">
                  <b-icon icon="upload"></b-icon>
                  <span>{{
                    $t('message.please_input') + $t('attributes.picture') + '2'
                  }}</span>
                </a>
                <p
                  v-if="form.picture2"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px; border-radius: 4px 0 0 4px;"
                >
                  <a
                    :href="productImageUrl(form.picture2)"
                    @click.prevent="onClickImage(form.picture2)"
                  >
                    {{ form.picture2 }}
                  </a>
                </p>
                <button
                  v-if="form.picture2"
                  class="button is-danger"
                  style="height: 40px; border-radius: 0 4px 4px 0;"
                  @click="form.picture2 = null"
                >
                  X
                </button>
              </b-field>
            </b-field>

            <b-field horizontal grouped :label="$t('attributes.picture') + '3'">
              <b-field class="file">
                <a class="button is-primary" @click="onSelectPicture(3)">
                  <b-icon icon="upload"></b-icon>
                  <span>{{
                    $t('message.please_input') + $t('attributes.picture') + '3'
                  }}</span>
                </a>
                <p
                  v-if="form.picture3"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px; border-radius: 4px 0 0 4px;"
                >
                  <a
                    :href="productImageUrl(form.picture3)"
                    @click.prevent="onClickImage(form.picture3)"
                  >
                    {{ form.picture3 }}
                  </a>
                </p>
                <button
                  v-if="form.picture3"
                  class="button is-danger"
                  style="height: 40px; border-radius: 0 4px 4px 0;"
                  @click="form.picture3 = null"
                >
                  X
                </button>
              </b-field>
            </b-field>

            <b-field horizontal grouped :label="$t('attributes.feature')">
              <div class="content">
                <editor
                  ref="feature_editor"
                  v-model="form.feature"
                  :area="area"
                ></editor>
              </div>
            </b-field>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ spot.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="productImageUrl(selectedImageUrl)" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  maxLength
} from 'vuelidate/lib/validators'
import { OpenProductFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'SpotForm',
  components: { Editor },

  props: {
    spot: {
      type: Object,
      required: true
    },
    area: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sequence_range: [...Array(20).keys()].map(i => i + 1),

      sending: false,
      form: this.extractFormValues(this.spot),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      sequence: {},
      name: { required, maxLength: maxLength(50) },
      subtitle: { maxLength: maxLength(50) },
      quantity: { required, numeric, minValue: minValue(1) },
      adult_cost: { required, numeric, minValue: minValue(0) },
      adult_tip: { maxLength: maxLength(50) },
      child_cost: { required, numeric, minValue: minValue(0) },
      child_tip: { maxLength: maxLength(50) },
      baby_cost: { required, numeric, minValue: minValue(0) },
      baby_tip: { maxLength: maxLength(50) }
    }
  },
  computed: {
    formTitle() {
      return (
        this.$t(this.spot.id ? 'attributes.modify' : 'attributes.add') +
        this.$t('attributes.spot')
      )
    }
  },
  watch: {
    spot(newSpot) {
      this.form = this.extractFormValues(newSpot)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        sequence: data.sequence || 10,
        name: data.name || '',
        subtitle: data.subtitle || '',
        quantity: data.quantity || 0,
        adult_cost: data.adult_cost || 0,
        adult_tip: data.adult_tip || '',
        child_cost: data.child_cost || 0,
        child_tip: data.child_tip || '',
        baby_cost: data.baby_cost || 0,
        baby_tip: data.baby_tip || '僅能同行無法體驗',
        feature: data.feature || '',
        picture1: data.picture1 || '',
        picture2: data.picture2 || '',
        picture3: data.picture3 || ''
      }
    },
    async onSend() {
      this.form.feature = this.$refs.feature_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    },
    async onSelectPicture(pictureIndex) {
      try {
        const path = await OpenProductFinder(this.area)
        this.setPicture(pictureIndex, path)
      } catch (e) {
        notifyService.error(e)
      }
    },
    setPicture(idx, picture) {
      switch (idx) {
        case 1:
          this.form.picture1 = picture
          break
        case 2:
          this.form.picture2 = picture
          break
        case 3:
          this.form.picture3 = picture
          break
        default:
          break
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>
